import { render } from "./NewGoal.vue?vue&type=template&id=7f6b5291&scoped=true"
import script from "./NewGoal.vue?vue&type=script&lang=js"
export * from "./NewGoal.vue?vue&type=script&lang=js"

import "./NewGoal.vue?vue&type=style&index=0&id=7f6b5291&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6b5291"]])

export default __exports__